export default __webpack_public_path__ + "static/media/R870_5.41dd66ab.png";